export function whetherMobile() {
  let uaReg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  let whether = navigator.userAgent.match(uaReg)
  
  let isMobile = whether == null ? false : true


  return isMobile
}
